import { api } from '../middleware/api';

// Define endpoints using injectApi pattern
export const foelinkroomsApi = api
  .enhanceEndpoints({ addTagTypes: ['FOELinkRooms'] })
  .injectEndpoints({
    endpoints: builder => ({
      getFOELinkRooms: builder.query<(fo_echeckin & fo_eroomshift)[], string>({
        query: cid => `foelinkrooms/${cid}`,
        providesTags: ['FOELinkRooms']
      }),
      getFOELinkRoomsById: builder.query<fo_eroomshift, string>({
        query: id => `foelinkrooms/byid/${id}`,
        providesTags: ['FOELinkRooms']
      }),
      insertFOELinkRooms: builder.mutation({
        query: foelinkrooms => ({
          url: `foelinkrooms/`,
          method: 'POST',
          body: foelinkrooms
        }),
        invalidatesTags: ['FOELinkRooms']
      }),
      updateFOELinkRooms: builder.mutation({
        query: foelinkrooms => ({
          url: `foelinkrooms/`,
          method: 'PUT',
          body: foelinkrooms
        }),
        invalidatesTags: ['FOELinkRooms']
      }),
      getFOEActiveLinkRooms: builder.query<any[], string>({
        query: cid => `foelinkrooms/active/${cid}`,
        providesTags: ['FOELinkRooms'],
      }),
      deleteFOELinkRooms: builder.mutation({
        query: foelinkrooms => {
          const id =
            typeof foelinkrooms === 'object'
              ? foelinkrooms.lr_id || foelinkrooms.id || foelinkrooms.rs_id
              : foelinkrooms;
          return {
            url: `foelinkrooms/${id}`,
            method: 'DELETE',
          };
        },
        invalidatesTags: ['FOELinkRooms'],
      }),
    }),
    overrideExisting: true,
  });

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetFOELinkRoomsQuery,
  useGetFOEActiveLinkRoomsQuery,
  useGetFOELinkRoomsByIdQuery,
  useInsertFOELinkRoomsMutation,
  useUpdateFOELinkRoomsMutation,
  useDeleteFOELinkRoomsMutation,
} = foelinkroomsApi;

